export default __webpack_public_path__ + "static/promo2-8ec061b26a35464cab269731cde6b5c2.mp4";